import { createTheme } from '@mui/material/styles';

export const jukTheme = createTheme({
  palette: {
    primary: {
      main: '#007037',
      light: '#F6EDD4',
      dark: '#007037',
    },
    secondary: {
      main: '#d81921',
      light: '#f3faf7',
      dark: '#fac6c8',
    },
    background: {
      default: '#f9fafb',
      paper: '#F3F4F6',
    },
    border: {
      primary: '#D5D6D8',
    },

    star: {
      empty: '#D1D5DB',
      filled: '#e6d130',
    },
    text: {
      primary: '#000000',
      secondary: '#111928',
      disabled: 'grey',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      disabled: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#ED1C24',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#ED1C24',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#ED1C24',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#008000',
      textAlign: 'left',
    },
    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: '#FFFEF7', //for arrow in button
      priceQuoteBackground: '#F8F1DC',
      ndrpSectionBackground: '#f9fafa',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#007037',
          borderRadius: '.5rem',
          '&:hover': {
            backgroundColor: '#870b0f',
          },
          color: '#FFFFFF',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(55 65 81)',
          fill: '#43b02a',
          '& .MuiSvgIcon-root': {
            '&:hover': {
              color: '#ED1C24',
            },
            '&.Mui-disabled': {
              color: '#9e9e9e',
            },
            color: '#ED1C24',
            fontSize: '1rem',
            width: '1.5rem',
            height: '1.5rem',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#007037',
          '&.Mui-checked': {
            color: '#007037',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
